module.exports = __webpack_public_path__ + "img/rubbish-bin-svgrepo-com.51c31125.svg";